import $ from 'jquery';

/**
 * Remembers the selection of a filter `<select data-remember="key">` in localStorage.
 *
 * A page opened without the select's parameter in its URL (e.g. from the navigation) is reloaded with the
 * remembered values, so the server renders the list filtered. Submitting the form stores the selection, and
 * submitting it with nothing selected forgets it, which is what keeps that reload from coming back.
 */
const storageKey = (key: string) => `RememberedSelection_${key}`;

function read(key: string): string[] {
  try {
    const parsed: unknown = JSON.parse(localStorage.getItem(storageKey(key)) ?? '[]');
    return Array.isArray(parsed) ? parsed.filter((value): value is string => typeof value === 'string') : [];
  } catch {
    return [];
  }
}

function write(key: string, values: string[]) {
  try {
    if (values.length > 0) {
      localStorage.setItem(storageKey(key), JSON.stringify(values));
    } else {
      localStorage.removeItem(storageKey(key));
    }
  } catch {
    // storage can be unavailable (private mode, blocked site data); the filter still works without it
  }
}

$(() => {
  $<HTMLSelectElement>('select[data-remember]').each(function () {
    const select = this;
    const key = select.dataset.remember;
    if (!key || !select.name) {
      return;
    }

    $(select.form ?? []).on('submit', () => {
      write(
        key,
        Array.from(select.selectedOptions, (option) => option.value)
      );
    });

    const params = new URLSearchParams(window.location.search);
    const name = select.name.toLowerCase();
    // model binding is case-insensitive, and redirects spell the parameter in PascalCase
    if (Array.from(params.keys()).some((param) => param.toLowerCase() === name)) {
      return;
    }

    // a remembered value can disappear, e.g. when the user loses access to a platform
    const available = new Set(Array.from(select.options, (option) => option.value));
    const remembered = read(key).filter((value) => available.has(value));
    if (remembered.length === 0) {
      return;
    }

    remembered.forEach((value) => params.append(select.name, value));
    window.location.replace(`${window.location.pathname}?${params}${window.location.hash}`);
  });
});
